import React from "react";

const ShippingAndDeliveryPolicy = () => {
    return (
        <div className='container mt-3'>

            <div className="row mb-4">
                <div className="col-md-12 mt-4 mb-2">
                    <h1 className='text-center mb-3 h1 fw-bold'>Shipping and Delivery Policy</h1>
                </div>
                <div className="shadow-sm p-4 pb-2 border rounded-3 bg-white">
                    <div className="row align-items-center ">


                        <p>At Exim Multimedia LLP, we strive to provide our Dcopy subscribers with a seamless and convenient reading experience. Since our Dcopy is a digital product, we do not require shipping in the classical sense. However, we understand that you may have questions about how to access your Dcopy subscription.</p>

                        <h5 className="fw-bolder">Accessing Your Dcopy Subscription</h5>

                        <p>1. Instant Access: Upon successful payment, you will receive an email with instructions on how to access your Dcopy subscription.</p>

                        <p>2. Digital Delivery: Your Dcopy subscription will be delivered digitally to your email inbox.</p>

                        <p>3. No Physical Delivery: Please note that we do not offer physical delivery of our Dcopy subscription.</p>

                        <h5 className="fw-bolder">Supported Devices</h5>
                        <p>Our Dcopy subscription can be accessed on a variety of devices, including:</p>

                        <p>1. Desktop computers (Windows, macOS, Linux)</p>

                        <p>2. Laptops (Windows, macOS, Linux)</p>

                        <p>3. Mobile devices (iOS, Android)</p>

                        <p>4. Tablets (iOS, Android)</p>

                        <h5 className="fw-bolder">System Requirements</h5>
                        <p>To ensure a smooth reading experience, please ensure that your device meets the following system requirements:</p>

                        <p>1. Operating System: Windows 10 or later, macOS 10.12 or later, iOS 12 or later, Android 8.0 or later</p>
                        <p>2. Browser: Google Chrome, Mozilla Firefox, Safari, Microsoft Edge</p>

                        <p>3. Internet Connection: Stable internet connection required for digital delivery and access</p>

                        <h5 className="fw-bolder">Contact Us</h5>

                        <p>If you have any questions or concerns about your Dcopy subscription, please do not hesitate to contact us at:</p>

                        <p>EXIM Multimedia LLP</p>

                        <p>subscription@exim-india.com</p>

                        <p>022-67571400</p>

                        <p>By subscribing to our Dcopy, you acknowledge that you have read, understood, and agree to be bound by this Shipping and Delivery Policy.</p>



                    </div>
                </div>
            </div>
        </div>
    )
}

export default ShippingAndDeliveryPolicy;